<template>
	<div v-if="!isAuth">
		<div class="w-full surface-0 relative 
			pb-5 xl:pb-8 lg:pb-6 md:pb-6 sm:pb-6 xl:px-2">
			<TitleScreen :title="content[lang_].title" :subtitle="content[lang_].subtitle" />
			<TransferScreen :currency_receive_first="'idr'" />
		</div>
		
		<MainHowItWorks />
		<MainReviewsSlider />
		<BannerPartner />
		<MainStat />
		<BannerFirstTransfer />
		<MainFeatures />
		<MainFaq  />
	</div>

	<!--app-->
	<TransferScreenApp v-else/>

</template>

<script>
import Helper 				from '@/assets/js/Helper.js'
import TitleScreen 			from '@/components/widgets/main/TitleScreen.vue' 
import TransferScreen 		from '@/components/widgets/main/TransferScreen.vue' 
import MainHowItWorks 		from '@/components/widgets/main/MainHowItWorks.vue'
import MainReviewsSlider 	from '@/components/widgets/main/MainReviewsSlider.vue' 
import BannerFirstTransfer 	from '@/components/widgets/main/BannerFirstTransfer.vue' 
import BannerPartner 		from '@/components/widgets/main/BannerPartner.vue' 
import MainStat 			from '@/components/widgets/main/MainStat.vue' 
import MainFeatures 		from '@/components/widgets/main/MainFeatures.vue' 
import MainFaq 				from '@/components/widgets/main/MainFaq.vue'
import TransferScreenApp 	from '@/components/widgets/main/TransferScreenApp.vue' 
import PartnerBalance 		from '@/components/widgets/main/PartnerBalance.vue' 
import { mapActions } 		from 'vuex'

export default {
	name: 'MainPage',
	data() {
		return {
			content: {
				en: {
					title: "Fast, secure international money transfers",
					subtitle: "send from 3000 rubles from Russia to Asian countries and back in 15 minutes to a card or ATM",
					authBtn: "Login",
					regBtn: "Register",
				} ,
				ru: {
					title: "Быстрые, безопасные международные денежные переводы",
					subtitle: "переводите от 3000 рублей из России в страны Азии и обратно за 15 минут на карту или банкомат",
					authBtn: "Войти",
					regBtn: "Регистрация",
				},
			}, 
		}
	},
	components: {
		TitleScreen,
		TransferScreen,
		MainHowItWorks,
		MainReviewsSlider,
		BannerFirstTransfer,
		BannerPartner,
		MainStat,
		MainFeatures,
		MainFaq,
		TransferScreenApp,
		PartnerBalance
	},
	watch: {},
	computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },	
		isAuth: function () { return this.$store.getters.isAuthenticated },
		isTgApp: function () { return this.$store.getters.StateTgApp },
		isDarkTheme() { return this.$store.getters.StateDarkTheme },
	},
	methods: {
		...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
	},
	async beforeCreate() {
		this.helper = new Helper()
	},
	mounted() {
		if(!this.isAuth){
			try {
				this.SetHeaderTitle(null)
				this.SetHeaderBtnLeftFirst({
					type: 'link',
					link: '/auth/',
					label: this.content[this.lang_].authBtn,
					icon: 'pi pi-sign-in',
					iconPos: 'right',
					severity: 'secondary',
					class: '',
					rounded: true,
					visible: true
				})
				this.SetHeaderBtnLeftSecond({})
				this.SetHeaderBtnRightFirst({
					type: 'link',
					link: '/reg/',
					label: this.content[this.lang_].regBtn,
					icon: 'pi pi-user-plus',
					iconPos: 'right',
					severity: 'primary',
					class: 'text-green-500',
					rounded: true,
					visible: true
				})
				this.SetHeaderBtnRightSecond({})
			} catch (error) {
				console.error('Error setting header:', error)
			}
		}
	}
}
</script>